import type { JSX } from 'react';
import { useMemo } from 'react';
import { useClearFocusedAsset } from '@frameio/selection';
import { useManageUbsValidateDialog } from './useManageUbsValidateDialog';

export type UbsValidateReturn = {
  openUbsValidateDialog: () => void;
  ubsValidateDialog: JSX.Element | null;
};

export const useUbsValidate = (): UbsValidateReturn => {
  const clearFocusedAssetId = useClearFocusedAsset();

  const { createUbsValidateDialog, openUbsValidateDialog } =
    useManageUbsValidateDialog();

  const ubsValidateDialog = useMemo(
    () =>
      createUbsValidateDialog({
        onClose: clearFocusedAssetId,
      }),
    [clearFocusedAssetId, createUbsValidateDialog]
  );

  return {
    openUbsValidateDialog,
    ubsValidateDialog,
  };
};
